import { create } from 'zustand'

interface ConfirmState {
  open: boolean
  title: string
  message: string
  onConfirm: (() => void) | null

  /** Open the confirm dialog. */
  show: (title: string, message: string, onConfirm: () => void) => void
  /** Close without confirming. */
  hide: () => void
  /** Confirm and close. */
  confirm: () => void
}

export const useConfirmStore = create<ConfirmState>()((set, get) => ({
  open: false,
  title: '',
  message: '',
  onConfirm: null,

  show: (title, message, onConfirm) =>
    set({ open: true, title, message, onConfirm }),

  hide: () => set({ open: false, title: '', message: '', onConfirm: null }),

  confirm: () => {
    const { onConfirm } = get()
    onConfirm?.()
    set({ open: false, title: '', message: '', onConfirm: null })
  },
}))
